module.exports = __webpack_public_path__ + "media/images/front/banner_jobmesse-91c3499889cbda3ba9229682e069212d.jpg";